/**
 * User-visible notices rendered next to the add-to-cart form, so upload or
 * generation failures are never silent.
 */

const NOTICE_ID = 'mokkoning-notice';

export function showError(form: HTMLFormElement, message: string): void {
    clearNotice();
    const notice = document.createElement('div');
    notice.id = NOTICE_ID;
    notice.setAttribute('role', 'alert');
    notice.style.cssText =
        'margin:12px 0;padding:10px 14px;background:#fcf0f1;border:1px solid #d63638;' +
        'border-radius:4px;color:#8a1f21;font-size:14px;';
    notice.textContent = message;
    form.parentNode?.insertBefore(notice, form);
    notice.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
}

export function clearNotice(): void {
    document.getElementById(NOTICE_ID)?.remove();
}
